module.exports = __webpack_public_path__ + "img/Mage-gnome-f-70.c8220011.gif";